import { SORT_COLUMNS } from '../../utils/employeeSort';
import { DENSITIES } from './rowLayout';

/**
 * `DirectoryColumnBand` is a 34px band rendered INSIDE the list card as its
 * first child, so it shares the card's box and its labels cannot drift from
 * the columns they name — an earlier version floated above the card and
 * needed a transparent 1px border to compensate for the card's edge. Must use
 * the same grid class, gap and padding as a row (rowLayout.js).
 */

function sortLabel(column, sortBy, onSortChange) {
  const active = sortBy === column.id;
  if (!onSortChange) {
    return <span className={active ? 'text-accent' : ''}>{column.label}</span>;
  }
  return (
    <button
      onClick={() => onSortChange(column.id)}
      className={`hover:text-ink-2 transition-colors ${active ? 'text-accent' : ''}`}
    >
      {column.label}
    </button>
  );
}

const byId = (id) => SORT_COLUMNS.find((c) => c.id === id);

export function DirectoryColumnBand({ density, sortBy, onSortChange }) {
  const d = DENSITIES[density] || DENSITIES.comfortable;

  return (
    <div className={`hidden md:grid w-full items-center gap-4 px-3.5 h-[34px]
                     bg-surface-2 border-b border-line
                     ${d.gridClass}
                     text-[10.5px] font-bold uppercase tracking-[0.08em] text-ink-3`}>
      <span />
      <span className="min-w-0 flex items-center whitespace-nowrap">{sortLabel(byId('lastName'), sortBy, onSortChange)}</span>
      <span className="min-w-0 flex items-center whitespace-nowrap">{sortLabel(byId('tenure'), sortBy, onSortChange)}</span>
      <span className="min-w-0 flex items-center whitespace-nowrap">{sortLabel(byId('department'), sortBy, onSortChange)}</span>
      <span className="hidden lg:flex items-center min-w-0 whitespace-nowrap">{sortLabel(byId('officeLocation'), sortBy, onSortChange)}</span>
      <span aria-hidden="true" />{/* spacer track */}
      <span className="flex items-center whitespace-nowrap normal-case">Actions</span>
    </div>
  );
}
